import { blockSettingFieldTypes } from '@/configuration/pages/ConfigurationPage/OrderTrackingPageConfiguration/constants'
import {
  getBlockDefinition,
  getBlockSettingFields,
  getBlockSettings,
} from '@/configuration/pages/ConfigurationPage/OrderTrackingPageConfiguration/helpers'
import {
  getBlockVisibilityErrors,
  getTextError,
  getTranslatedTextError,
  pickErrors,
} from '@/configuration/pages/ConfigurationPage/OrderTrackingPageConfiguration/TrackingPageEditorModal/helpers'

const getFieldError = (field, value, languages) => {
  if (field.type === blockSettingFieldTypes.translatedText) return getTranslatedTextError(field, value, languages)
  if (field.type === blockSettingFieldTypes.text) return getTextError(field, value)

  return null
}

export const getBlockSettingsErrors = (definition, settings, languages) => {
  const entries = getBlockSettingFields(definition).map(field => {
    return [field.key, getFieldError(field, settings[field.key], languages)]
  })

  return pickErrors(entries)
}

export const getBlockErrors = ({ definition, settings, visibility, languages }) => {
  return {
    settings: getBlockSettingsErrors(definition, settings, languages),
    visibility: definition.supportsVisibility ? getBlockVisibilityErrors(visibility) : {},
  }
}

export const countBlockErrors = blockErrors => {
  return Object.keys(blockErrors.settings).length + Object.keys(blockErrors.visibility).length
}

export const getLayoutErrors = ({ layout, blockSettings, getBlockVisibility, languages }) => {
  const entries = layout.map(item => {
    const definition = getBlockDefinition(item.i)
    const blockErrors = getBlockErrors({
      definition,
      settings: getBlockSettings(definition, blockSettings[item.i]),
      visibility: getBlockVisibility(item.i),
      languages,
    })

    return [item.i, blockErrors]
  })

  return Object.fromEntries(entries.filter(([, blockErrors]) => countBlockErrors(blockErrors) > 0))
}

export const getBlockErrorCount = (layoutErrors, blockId) => {
  if (!layoutErrors[blockId]) return 0

  return countBlockErrors(layoutErrors[blockId])
}

export const countLayoutErrors = layoutErrors => {
  return Object.values(layoutErrors).reduce((total, blockErrors) => total + countBlockErrors(blockErrors), 0)
}

export const commitLayoutErrors = (layoutErrors, openBlockId, openBlockErrors) => {
  if (!openBlockId) return layoutErrors

  const { [openBlockId]: _openBlockLiveErrors, ...committedErrors } = layoutErrors

  if (!openBlockErrors) return committedErrors

  return { ...committedErrors, [openBlockId]: openBlockErrors }
}
